import UiListItem from "./UiListItem";
import MiezzListItem from "@/models/MiezzListItem";
import { EnumPipe } from "@/models/EnumPipe";
import { EnumEquivalentUnit, EnumEquivalentUnitOption } from "./EnumEquivalentUnit";
import { EnumParamAuditStatus, EnumParamAuditStatusOption } from "./EnumParamAuditStatus";

/**
 * 箱型分页列表-项
 * @description 自动生成的代码,请勿修改
 */
export default class DtoListItemParamContainerType extends UiListItem<string> {
    constructor() {
        //无参构造函数
        super()
        this.Status = EnumParamAuditStatus.Not;
        this.IsEdit = false;
    }

    [proName: string]: any;
    /**
     * ISO
     */
    Iso?: string;
    /**
     * 95码
     */
    Code?: string;
    /**
     * 中文名称
     */
    NameZh?: string;
    /**
     * 英文名称
     */
    NameEn?: string;
    /**
     * 全名
     */
    FullName?: string;
    /**
     * 柜量
     */
    EquivalentUnit?: EnumEquivalentUnit;
    /**
     * 审核状态
     */
    Status?: EnumParamAuditStatus;
    /**
     * 是否可以编辑
     */
    IsEdit?: boolean;
    /**
     * 创建人所属公司
     */
    CreatedCompanyId?: string;
}

/**
 * 箱型分页列表-项-表单校验
 */
export const DtoListItemParamContainerTypeRules = {
}

/**
 * 箱型分页列表-项-设置项
 */
export const DtoListItemParamContainerTypeMiezzListItems: MiezzListItem[]  = [
  {
    Prop: "Iso",
    Label: "ISO",
  },
  {
    Prop: "Code",
    Label: "95码",
  },
  {
    Prop: "NameZh",
    Label: "中文名称",
  },
  {
    Prop: "NameEn",
    Label: "英文名称",
  },
  {
    Prop: "FullName",
    Label: "全名",
  },
  {
    Prop: "EquivalentUnit",
    Label: "柜量",
    Pipe: EnumPipe.Enum,
    Options: EnumEquivalentUnitOption,
  },
]
